/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { focus: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        color: '#414547',
        iconColor: '#414547',
        iconSize: 26
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        color: '#4b286d',
        iconColor: '#4b286d',
        iconSize: 22
      }
    },
    { if: { hover: true }, tokens: { iconSize: 26 } }
  ],
  tokens: {
    activeColor: '#4b286d',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 4,
    color: '#676e73',
    fontName: 'HNforTELUSSA',
    fontWeight: '500',
    iconColor: '#676e73',
    iconSize: 24,
    lineHeight: 1.14285714286,
    paddingBottom: 4,
    paddingTop: 4
  }
}
export default theme
